var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{ invert: !_vm.darkMode },attrs:{"src":"https://creative-content.aftvrsys.com/image-alternatives/light/favicon-128x128.png","alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }